/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/* eslint-disable no-plusplus */

/**
 * The EventEmitter is the base class for the EventBus
 */
export class EventEmitter {
  listeners = [];

  /**
   * Add event listener.
   */
  addEventListener(type, callback) {
    const listener = { type, callback };
    this.listeners.push(listener);
    return listener;
  }

  /**
   * Remove event listener.
   * @param listener - Event listener to remove.
   */
  removeEventListener(listener) {
    for (let c = 0; c < this.listeners.length; c++) {
      if (listener === this.listeners[c]) {
        this.listeners.splice(c, 1);
        return;
      }
    }
  }

  /**
   * Remove event listeners.
   * @param listeners - List of event listeners to remove.
   */
  removeEventListeners(listeners) {
    listeners.forEach((listener) => {
      this.removeEventListener(listener);
    });
  }

  /**
   * Trigger event.
   * @param ce - Custom event to dispatch.
   */
  dispatchEvent(ce) {
    const listeners = this.listeners.slice();
    listeners.forEach((l) => {
      if (ce.type === l.type) {
        // @ts-ignore
        l.callback.apply(this, [ce]);
      }
    });
  }
}
